<template>
  <span class="w3-cell-row">

    <select class="w3-select w3-cell" @change="changed" v-model="selected" style="width:30%">
              <!-- <option disabled value="">Please select one</option> -->
              <option value="currentlocation" selected>Current</option>              
              <option value="mylocation">Mine</option>              
              <option v-if="home" value="shoplocaton">Shop</option>
    </select>
    &nbsp;<open-gooogle-maps v-if="fieldModelValue" class="w3-cell" :latitude="fieldModelValue.latitude" :longitude="fieldModelValue.longitude">Show</open-gooogle-maps>            
  </span>
</template>
<script>
  import {
    mapGetters,
    mapActions
  } from "vuex";
export default {    
  props:["value","home"],
  data: function() {
      return {
        selected:'currentlocation',
        original:null
      };
  },
  methods:{
    ...mapActions(["setToastMessage"]),
    OpenGoogleMaps(){
        window.open(`https://www.google.com/maps/?q=${this.latitude},${this.longitude}`)
    }  ,
    changed(e){        
        let newval = {...this.value}
        switch (this.selected) {
          case 'currentlocation':   
            if(!this.original)
            {
              this.setToastMessage({ type: 'error', message: `Sorry no original location found`, title: 'Locaton Error' })           
              break;
            }
            newval.latitude = this.original.latitude
            newval.longitude = this.original.longitude   
            this.fieldModelValue = newval            
            break;        
          case 'mylocation': 
            if(!this.location)
            {
              this.setToastMessage({ type: 'error', message: `Sorry your location is not set. Set this using the icon to the bottom right`, title: 'Locaton Error' })           
              break;
            }
            newval.latitude = this.location.latitude
            newval.longitude = this.location.longitude   
            this.fieldModelValue = newval
            break;                    
          case 'shoplocaton':            
            if(!this.home){
              this.setToastMessage({ type: 'error', message: `Sorry your home location is not set, this will need to be configured at the admin common page by an administrator.`, title: 'Locaton Error' })           
              break;
            }
            newval.latitude = this.home.latitude
            newval.longitude = this.home.longitude    
            this.fieldModelValue = newval         
            break;     
          default:
            break;
        }
    }
  },
  computed: { 
    ...mapGetters(["location"]),
    fieldModelValue: {
          get() {
            return this.value;
          },
          set(newValue) {
            this.setToastMessage({ type: 'info', message: `Location changed don't forget to save`, title: 'Locaton'})
            this.$emit('input', newValue);
          }
    } 
  },
  created(){
      this.original = {latitude:this.value.latitude,longitude:this.value.longitude}
  }
};
</script>
  <style>
   
  </style>


// WEBPACK FOOTER //
// src/components/shared/controls/buttons/SetLocationButton.vue